import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { v4 as uuid } from "uuid";
import { BFXAppNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXAppNotificationType";

/**
 * Data class representing a single notification setting for App notifications. Similar to
 * popup notification but with extra field for retriving events on login
 */
export class BfxAppEventSetting {
  public type: BFXAppNotificationType;
  public blotterType: CubiqTS.BlotterType;
  public eventIdentifier: string = "";
  public enabled: boolean = false;
  public audio: any = null;
  public disableAllAudio: boolean = false;
  public filter: {
    id: string;
    name: string;
    blotterType: number;
  } = null;
  public filterList: Array<any> = [];
  public returnOnLogin: boolean = null;
  public isBmark: boolean = false;

  constructor(
    type: BFXAppNotificationType,
    eventIdentifier: string,
    enabled: boolean,
    returnOnLogin: boolean = null,
    audio: any,
    disableAllAudio: boolean,
    filter: any,
    blotterType: CubiqTS.BlotterType,
    isBmark: boolean = false,
  ) {
    this.type = type;
    this.eventIdentifier = eventIdentifier;
    this.enabled = enabled;
    this.audio = audio;
    this.disableAllAudio = disableAllAudio;
    this.filter = filter;
    this.blotterType = blotterType;
    this.returnOnLogin = returnOnLogin;
    this.isBmark = typeof isBmark === "boolean" ? isBmark : false;
  }
}
